import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import Layout from '@/components/Layout'
import ScrollToTop from '@/components/ScrollToTop'

const Home = lazy(() => import('@/pages/Home'))
const About = lazy(() => import('@/pages/About'))
const Schedule = lazy(() => import('@/pages/Schedule'))
const Gallery = lazy(() => import('@/pages/Gallery'))
const FindMe = lazy(() => import('@/pages/FindMe'))
const TheWall = lazy(() => import('@/pages/TheWall'))
const NotFound = lazy(() => import('@/pages/NotFound'))

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="find-me" element={<FindMe />} />
          <Route path="the-wall" element={<TheWall />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  )
}
